import angular from 'angular';

import ChartComponent from './chart.cmpt';

export default angular
    .module('application.scene.authorized.scene.dashboard.component.chart', [])
    .component(ChartComponent.selector, ChartComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/chart/index.js